import { render, staticRenderFns } from "./TaskNav.vue?vue&type=template&id=041662f9&scoped=true"
import script from "./TaskNav.vue?vue&type=script&lang=js"
export * from "./TaskNav.vue?vue&type=script&lang=js"
import style0 from "./TaskNav.vue?vue&type=style&index=0&id=041662f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041662f9",
  null
  
)

export default component.exports